/** @format */

import React, { Component } from 'react';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';

import IccidMvnoChange from './MvnoAdmin/IccidChange';
import { store } from '../../core/store';
import { platformResellerReducers } from '../../modules/platformreseller/reducers';

class IccidCommon extends Component {
    constructor(props, context) {
        super(props, context);
        store.injectReducer('platformResellerReducers', platformResellerReducers);
    }

    render() {
        return (
            <GridContainer>
                <GridItem xs={5}>
                    <IccidMvnoChange />
                </GridItem>
                <GridItem xs={5}></GridItem>
            </GridContainer>
        );
    }
}

export default IccidCommon;
